import { createContext, useContext } from 'react';
import type * as server from 'bb-elysia-server';
import { treaty, edenFetch } from '@elysiajs/eden';
import type { Elysia } from 'elysia';

export type ElysiaServer = server.ElysiaServer;

const api = () => treaty<ElysiaServer>('');
export type TreatyClient = ReturnType<typeof api>;

type TreatyFetch = ReturnType<typeof makeFetch>;
type TreatyRoute = Parameters<TreatyFetch>[0];
export type RouteData<T extends TreatyRoute> = NonNullable<Awaited<ReturnType<typeof fetchData<T>>>['data']>;

type GetSchema<T extends Elysia<any, any, any, any, any, any, any>> = T extends {
  '~Routes': infer R;
}
  ? R
  : never;
export type ElysiaSchema = GetSchema<ElysiaServer>;

const makeFetch = () => edenFetch<ElysiaServer>('');
function fetchData<T extends TreatyRoute>(route: T) {
  const fetch = makeFetch();
  // @ts-ignore
  return fetch(route, { method: 'GET' });
}

export const ApiClientContext = createContext<TreatyClient | null>(null);

export function useApiClient() {
  const client = useContext(ApiClientContext);
  if (!client) {
    throw new Error('ApiClientContext not found');
  }

  return client;
}
